import React, { Component, StatelessComponent, Fragment } from 'react';
import { Link, Route } from 'react-router-dom';
import b from 'b_';

import './not-found.css';

import Homepage from '@interfaces/homepage';
import PublicationItem from '@components/publication-item';
import News, { NewsStub } from '@components/news-widget';
import PageMeta from '@components/page-meta';
import Rect from '@components/rect';
import { Publication } from '@interfaces/publications-page';
import EntitiesBlock from '@components/entities-block';
import { SizesProps } from '@interfaces/sizes-props';

// Компонент нужен для передачи статуса при серверном рендеринге
// Например если страница не найдена, отдаем клиенту 404 ошибку
const Status: StatelessComponent<any> = ({ code, children }) => {
    const render = ({ staticContext }: any) => {
        if (staticContext) {
            staticContext.status = code;
        }

        return children;
    };

    return (
        <Route render={render} />
    );
};

export interface DispatchProps {
    fetchHomepage(): void;
}

export interface StateProps {
    data: Homepage;
    isLoading: boolean;
}

type Props = SizesProps & StateProps & DispatchProps & {};

const class_ = b.with('not-found');

export default class NotFoundPage extends Component<Props> {
    public componentDidMount() {
        if (!this.props.data.news.length) {
            this.props.fetchHomepage();
        }
    }

    public shouldComponentUpdate() {
        return true;
    }

    public renderPublication = (publication: Publication) => (
        <PublicationItem type="vertical" entity={publication} />
    );

    public renderWidgets = () => {
        const { data: { news, publications }, isLoading, isDesktop } = this.props;

        if (isLoading) {
            return (
                <div className="block centering">
                    <div className="block__head">
                        <Rect width={150} height={48} type="black" />
                        <span className="block__title-link">
                            <Rect width={100} height={24} />
                        </span>
                    </div>
                    <NewsStub itemsCount={3} />
                </div>
            );
        }

        return (
            <div className={class_('content')}>
                {Boolean(news.length) &&
                    <Fragment>
                        <div className="block__separator" />
                        <div className="block">
                            <div className="block__head">
                                <div className="block__title">News</div>
                                <Link to="/news" className="block__title-link">All news</Link>
                            </div>
                            <News
                                compact={!isDesktop}
                                items={news}
                            />
                        </div>
                    </Fragment>
                }
                {Boolean(publications.length) &&
                    <Fragment>
                        <div className="block__separator" />
                        <EntitiesBlock
                            key="publications"
                            className="publications"
                            title="Latest publications"
                            linkToAllEntities={{ text: 'All publications', url: '/publications' }}
                            entities={publications}
                            renderItem={this.renderPublication}
                        />
                    </Fragment>
                }
            </div>
        );
    };

    public render() {
        return (
            <Status code={404}>
                <PageMeta title="Page not found" />
                <div className={class_()}>
                    <h1 className={class_('title')}>This request is not solvable.</h1>
                    <div className={class_('text')}>
                        <div>
                            <span>This is related to the </span>
                            <a
                                href="https://en.wikipedia.org/wiki/Gödel%27s_incompleteness_theorems"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Gödel&apos;s incompleteness theorems
                            </a>
                        </div>
                        <div>Sorry</div>
                    </div>

                    {this.renderWidgets()}
                </div>
            </Status>
        );
    }
}
